import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

function onRender() {
  // register after first render to ensure that `newVersionAvailable` event
  // is not missed by components
  registerServiceWorker()
}

ReactDOM.render(<App />, document.getElementById('root'), onRender)



// WEBPACK FOOTER //
// ./src/index.js